import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/apply/img-file-upload.svg'
import _imports_1 from '@/assets/img/apply/icon-checked.svg'
import _imports_2 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-08a97428"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = {
  class: "l-wrapper_main",
  style: {"background-color":"#e6eff6"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "一括応募確認", -1))
const _hoisted_4 = { class: "p-apply" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-apply_headingLv1 u-mn-hidden" }, "一括応募確認", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-apply_text" }, [
  /*#__PURE__*/_createTextVNode(" 「現時点の志望度」があれば教えてください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ご入力いただいた内容は企業へ共有いたしません。 ")
], -1))
const _hoisted_7 = { class: "p-apply_number" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_9 = { class: "p-apply-card-list -block" }
const _hoisted_10 = { class: "p-apply-card_heading word_break" }
const _hoisted_11 = { class: "p-apply_label-radio" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "現時点での志望度", -1))
const _hoisted_13 = ["name", "value", "onUpdate:modelValue"]
const _hoisted_14 = { class: "label-number" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "低い", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "高い", -1))
const _hoisted_17 = { class: "p-apply_button-wrap" }
const _hoisted_18 = {
  class: "c-modal js-modal-container",
  id: "apply"
}
const _hoisted_19 = {
  class: "c-modal_inner",
  style: {"max-width":"400px"}
}
const _hoisted_20 = { class: "c-modal_content" }
const _hoisted_21 = { class: "js-apply-tab" }
const _hoisted_22 = { class: "p-apply-modal" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_24 = {
  key: 0,
  class: "p-apply-modal_heading"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "js-apply-tab" }
const _hoisted_28 = { class: "p-apply-modal" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_30 = { class: "p-apply-modal_heading" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-modal_bg" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-wrapper_nav" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "g-to-top",
    href: "#",
    "aria-label": "ページトップへ戻る"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })
  ])
], -1))

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { MultipleOrderApply, OrderApply, OrderInfo, UpdateResponse } from '@/types';
import { submitUpdateApplyMultipleShintyokuService } from '@/api/services/shintyokuService';
import { getOrdersDetail } from '@/api/shintyokuEndpoint';
import { eventBus } from '@/events/eventBus';
import Loading from '@/components/Loading.vue';
import { MYPAGE_CONSTANTS } from '../../constants/mypage';
import { mypageUtils } from '@/utils/mypage';
import { useStore } from 'vuex';
import { OrdersInfo } from '@/store/modules/orders';
import { handleGTMEvent } from '@/utils/gtmEventHelper';
// Ref

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyMultipleView',
  setup(__props) {

const btnApply = ref<HTMLButtonElement | null>(null);
const orderApplies = ref<MultipleOrderApply[]>([]);

const orderSuccess = ref<MultipleOrderApply[]>([]);
const orderInfos = ref<OrderInfo[]>([]);

// Modal Events
const showModal = ref(false);
const isConfirmed = ref(false);
const btnClose = ref(true);
const errorMessage = ref('');
const successMessage = ref('0');
const submitSuccess = ref(false);
const isLoading = ref<boolean>(false);

const isExistSuscess = ref<boolean>(false);
const store = useStore();
// Route => Get Params
const route = useRoute();
const router = useRouter();

let orderIds: number[] = [];
const screenName = route.query.screen;
if (Array.isArray(route.query.orderIds)) {
  orderIds = route.query.orderIds.map(Number);
} else if (route.query.orderIds) {
  orderIds = route.query.orderIds.split(',').map(Number);
}

const handleShowTitleSuccess = (size: number, ) => {
  return size > 1 ? ' ほか' : ''; 
};

// Methods
/**
 * Show modal to confirm Apply
 * @param isShow
 */
const handleShow = (isShow: boolean) => {
  showModal.value = isShow;
  btnClose.value = !isShow;  
};

const handleInitConfirm = () => {
  resetValueRef();
  handleShow(true);
};

const handleBack = () => {
  window.history.back();
};

const handleLeaveForm = () => {
  if (submitSuccess.value) {
    router.push('/apply/');
    return;
  }
  if(isExistSuscess.value)
  {
      errorMessage.value = '';
      isExistSuscess.value = false;
      isConfirmed.value = true;
      submitSuccess.value = true;
  }
  else
  {
    resetValueRef();
  }
};

/**
 * Reset value refs
 */
const resetValueRef = () => {
  showModal.value = false;
  isConfirmed.value = false;
  btnClose.value = true;
  errorMessage.value = '';
  submitSuccess.value = false;
  isExistSuscess.value = false;
  document.body.style.overflow = '';
};

/**
 * Handles the click event for the apply button in the footer.
 * If the status message is 'ACTIVE', programmatically clicks the apply button.
 *
 * @param msg - The status message to check
 */
function handleClickButtonApplyFromFooter(msg: string) {
  if (msg === 'ACTIVE') {
    resetValueRef();
    btnApply.value?.click();
    showModal.value = true;
  }
}

const handleClickOutSideModal = (event: Event) => {
  const target = event.target as Element | null;
  // Check if the click was inside the model-confirm-form div
  if (target && !target.closest('.c-modal_inner') && submitSuccess.value) {
    router.push('/apply/');
    return;
  }
};

onMounted(async () => {
  // If there are no orderIds or the orderIds are not valid numbers,
  // redirect to the 404 page and exit
  if (orderIds.length === 0 || !handleCheckParamValidNumbers(orderIds)) {
    router.replace({ path: 'mynavi/404' });
    return;
  }
  // Enable event
  eventBus.on('click-apply-event', handleClickButtonApplyFromFooter);
  isLoading.value = true;
  // For each orderId, fetch the company name and job title,
  // then add a MultipleOrderApply object to orderApplies
  const orders = await getOrdersDetail({orderIds: orderIds});

  // Set Orders Info State to using for the GTM Trigger
  const ordersInfoState: OrdersInfo = {
    orders: [...orders].map((order: OrderInfo) => ({
      orderId: order.orderId,
      isAiRecommended: order?.trnShintyokuWithCareer?.[0]?.isAiRecommended ?? false,
      isNewRecommended: order?.trnShintyokuWithCareer?.[0]?.isNewRecommended ?? false,
    })),
    fromPage: undefined,
  };
  store.commit('orders/setOrdersInfo', ordersInfoState);

  handleGTMEvent(orderIds);

  if(!(orders) || (screenName != MYPAGE_CONSTANTS.SCREN_NAME_MULTI_APPLY.PENDING && screenName != MYPAGE_CONSTANTS.SCREN_NAME_MULTI_APPLY.JOBSEARCH))
  {
    router.replace({ path: 'mynavi/404' });
    return;
  }
  for (const orderId of orderIds) {
    const orderInfo = orders.find(v => v.orderId === orderId);
    if (orderInfo) {
      orderInfos.value.push(orderInfo);
      const orderApply: MultipleOrderApply = {
        orderApply: { orderId: orderId, aspiration: 3 },
        orderApplyName: orderInfo.clientName + '／' + orderInfo.positionname,
        orderProgressType: orderInfo.orderProgressType
      };
      orderApplies.value.push(orderApply);
    }
  }
  isLoading.value = false;
  document.addEventListener('click', handleClickOutSideModal);
});
onBeforeUnmount(() => {
  eventBus.off('click-apply-event', handleClickButtonApplyFromFooter);
  document.removeEventListener('click', handleClickOutSideModal);
});

/**
 * Handles the submission of a apply request.
 * If already confirmed, just resets values and returns.
 * Otherwise, prepares the request and submits it.
 */
const handleSubmitApply = async (): Promise<void> => {
  // If already confirmed, reset and exit
  if (isConfirmed.value) {
    if(isExistSuscess.value)
    {
       isExistSuscess.value = false;
       errorMessage.value = '';
       isConfirmed.value = true;
       submitSuccess.value = true;
       return;
    }
    else
    {
      resetValueRef();
      return;
    }
  }

  handleShow(false);
  isLoading.value = true;
  // Extract orderApply objects from orderApplies
  
  const privateOrders: OrderApply[] = orderApplies.value.filter(v => (v.orderProgressType === 'INTRODUCTION')).map((v) => v.orderApply);
  const publicOrders: OrderApply[] = orderApplies.value.filter(v => v.orderProgressType === 'PUBLIC' || v.orderProgressType === 'REFUSAL').map((v) => v.orderApply);
  const wrongTypeOrderIds: number[] = orderApplies.value.filter(v => v.orderProgressType !== 'INTRODUCTION' && v.orderProgressType !== 'PUBLIC' && v.orderProgressType !== 'REFUSAL' ).map((v) => v.orderApply.orderId);
  // Submit the apply request
  const response = await submitUpdateApplyMultipleShintyokuService(publicOrders, privateOrders) as UpdateResponse;
  // Show the result message to the user
  await handleShowMessage(response, response.successOrders??[], wrongTypeOrderIds);
};

/*
 * Handles the display of messages based on the response from an update operation.
 * @param response - The response object from the update operation, or null if no response is available.
 */
const handleShowMessage = async (response: UpdateResponse | null, sucessOrderIds: number[], wrongTypeOrderIds: number[]) => {
  // Check if the response is null and handle the null case if needed
  if (!response) {
    // If there's no response, exit the function early
    return;
  }
  const arrError = [];
  // Check for ignored orders and set an error message if any are found
  if ((response.ignoreOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_BULK, response.ignoreOrders));
  }

  // Check for unapproved orders and set an error message if any are found
  if ((response.unApprovedOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS, response.unApprovedOrders));
  }

  // Check for unavailable orders and set an error message if any are found
  if ((response.unAvailableOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_SEL_ON_BRIEFING_SESSION_MULTI, response.unAvailableOrders));
  }

  // Check for other exceptions and set an error message if any are found // 進捗の更新(TRNSHINTYOKU)で例外が発生した場合：進捗履歴情報の登録に失敗しました。
  if (typeof response.otherException === 'string' && response.otherException.length > 0) {
    arrError.push(handleMessage(MYPAGE_CONSTANTS.STRING.FAIL_REGISTER_PROGRESS_HISTORY_MSG));
  }

  // Check for order apply for public search exceptions and set an error message if any are found
  if (typeof response.orderPublicApplySearchException === 'string' && response.orderPublicApplySearchException.length > 0 && (response.publicUnProgressOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.INTRODUCED_CONTACT_DESCRIPTION, response.publicUnProgressOrders));
  }

  // Check for order apply for public exceptions and set an error message if any are found
  if (typeof response.orderPublicApplyException === 'string' && response.orderPublicApplyException.length > 0 && (response.publicInValidOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_AVAILABLE_JOB_MSG,  response.publicInValidOrders));
  }

  if(wrongTypeOrderIds.length > 0)
  {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_BULK,  wrongTypeOrderIds));
  }

  if(arrError.length)
  {
    errorMessage.value = arrError.join('</br></br>');
  }
  
  const numberSuccess = sucessOrderIds.length;    
  successMessage.value = numberSuccess.toString() ?? '0';
  if(sucessOrderIds && sucessOrderIds.length)
  {
    orderSuccess.value = orderApplies.value.filter(v=>sucessOrderIds.includes(v.orderApply.orderId));
  }

  // Determine whether to show a confirmation or success message
  if (errorMessage.value.length > 0) {
    // If there is an error message, set the confirmation flag
    submitSuccess.value = false;
    isConfirmed.value = true;

    if(numberSuccess > 0)
    {
      isExistSuscess.value = true;
    }
    else
    {
      isExistSuscess.value = false;
    }
  } else {
    // If there are no error messages, set both confirmation and success flags
    successMessage.value = numberSuccess.toString() ?? '0';
    isConfirmed.value = true;
    submitSuccess.value = true;
    document.body.style.overflow = '';
  }
  handleShow(true);
  isLoading.value = false;
};

/**
 * Appends detailed information for invalid order IDs to the given message.
 *
 * @param msg - The base message string.
 * @param invalidOrderIds - Array of invalid order IDs, or null.
 * @returns The message with additional details for each invalid order.
 */
const handleMessageForInvalidOrders = (msg: string, invalidOrderIds: number[] | null | undefined) => {
  if (invalidOrderIds === null || !invalidOrderIds || invalidOrderIds.length === 0) {
    return msg;
  }
  for (let orderId of invalidOrderIds) {
    const orderInfoResponse = orderInfos?.value?.find((e) => e.orderId === orderId);
    if (orderInfoResponse != null) {
      msg += '<br/>' + orderId + ' : ' + orderApplies.value.filter((v) => v.orderApply.orderId === orderId).map((v) => v.orderApplyName);
    }
  }
  return msg;
};

/**
 * Generates a formatted message.
 *
 * @param msg - The base message to be displayed.
 * @returns A formatted string containing all provided details.
 */
const handleMessage = (msg: string): string => {
  return msg;
};

/**
 * Checks if the orderIds array contains only valid numbers and is not empty.
 *
 * @param orderIds - Array of order IDs to validate
 * @returns true if all elements are valid numbers and array is not empty, false otherwise
 */
const handleCheckParamValidNumbers = (orderIds: number[]): boolean => {
  return orderIds.length > 0 && orderIds.every((x) => !Number.isNaN(x));
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("div", { class: "c-head-mn u-lg-hidden" }, [
        _createElementVNode("button", {
          onClick: handleBack,
          "aria-label": "戻る"
        }),
        _hoisted_3
      ]),
      _createElementVNode("main", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(" 全 "),
          _createElementVNode("span", null, _toDisplayString(orderApplies.value.length), 1),
          _createTextVNode(" 件 ")
        ]),
        _createElementVNode("form", null, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderApplies.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "p-apply-card -block",
                key: item.orderApply.orderId
              }, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(item.orderApplyName), 1),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                      return _createElementVNode("label", {
                        key: n,
                        class: _normalizeClass(["custom-radio-label", { highlighted: item.orderApply.aspiration !== null && n <= item.orderApply.aspiration }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: item.orderApply.aspiration?.toString(),
                          value: n,
                          "onUpdate:modelValue": ($event: any) => ((item.orderApply.aspiration) = $event),
                          class: "real-radio"
                        }, null, 8, _hoisted_13), [
                          [_vModelRadio, item.orderApply.aspiration]
                        ]),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(n), 1)
                      ], 2)
                    }), 64)),
                    _hoisted_15,
                    _hoisted_16
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "u-modal-open-button js-modal-open-button",
              ref_key: "btnApply",
              ref: btnApply,
              "data-modal-target": "apply",
              type: "button"
            }, [
              _createElementVNode("span", {
                class: "p-apply_button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleInitConfirm()))
              }, "一括で応募する")
            ], 512),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "c-modal_close",
                  type: "button",
                  "aria-label": "閉じる",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleLeaveForm()))
                }),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", null, [
                        _hoisted_23,
                        (!isConfirmed.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                              _createTextVNode(_toDisplayString(orderApplies.value.length) + "件応募します。 ", 1),
                              _hoisted_25,
                              _createTextVNode(" よろしいでしょうか？ ")
                            ]))
                          : (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              class: "p-apply-modal_heading",
                              innerHTML: errorMessage.value
                            }, null, 8, _hoisted_26))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "p-apply-modal_button -apply",
                          type: "button",
                          onClick: handleSubmitApply
                        }, "OK"),
                        _withDirectives(_createElementVNode("button", {
                          class: "p-apply-modal_button",
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (resetValueRef()))
                        }, " キャンセル ", 512), [
                          [_vShow, !isConfirmed.value]
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, !submitSuccess.value]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", null, [
                        _hoisted_29,
                        _createElementVNode("p", _hoisted_30, [
                          _createTextVNode(_toDisplayString(successMessage.value) + "件の応募を ", 1),
                          _hoisted_31,
                          _createTextVNode(" 受け付けました ")
                        ])
                      ]),
                      _createElementVNode("p", {
                        class: "p-apply-modal_text",
                        innerHTML: orderSuccess.value.map((v) => v.orderApplyName)[0] + handleShowTitleSuccess(orderSuccess.value.length)
                      }, null, 8, _hoisted_32),
                      _createElementVNode("div", null, [
                        _createVNode(_component_router_link, {
                          class: "p-apply-modal_button -apply",
                          to: "/apply/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("応募管理画面へ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          class: "p-apply-modal_button -apply",
                          to: "/jobsearch/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("求人一覧へ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 512), [
                    [_vShow, submitSuccess.value]
                  ])
                ])
              ]),
              _hoisted_33
            ], 512), [
              [_vShow, showModal.value]
            ])
          ])
        ])
      ])
    ]),
    _hoisted_34
  ]))
}
}

})